// src/components/fancy/TypeText.jsx
"use client";
import React from "react";
import { motion } from "framer-motion";

export default function TypeText({
  text,
  className = "",
  charDelay = 0.06,    // seconds per character
  startDelay = 0,      // delay before typing starts
}) {
  return (
    <span aria-label={text} className={className}>
      {text.split("").map((ch, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: startDelay + i * charDelay, duration: 0.04 }}
        >
          {ch}
        </motion.span>
      ))}
    </span>
  );
}
